/* 首页 卡片右键菜单  hooks
*
* */
import {nextTick, ref} from 'vue'
import {until} from '@vueuse/core'

const useHomeContextmenu = () => {
// ElPopover 的visbile属性
    const visibleContextPopper = ref(false)
    // 当前行信息
    const currentRow = ref({})
    //virtual-ref 对应的dom
    const contextmenuPopRef = ref()
    //
    const showContextmenuPopper = async (e, row) => {
        try {
            const evt = e || window.event
            evt.stopPropagation()
            evt.preventDefault()
            // 通过设置false 销毁popover, 解决闪现问题
            if (contextmenuPopRef.value) {
                visibleContextPopper.value = false
            }
            await nextTick()
            // 显示浮窗
            contextmenuPopRef.value = evt.target
            visibleContextPopper.value = true
            await until(() => contextmenuPopRef.value).toBeTruthy({timeout: 3000})
            currentRow.value = row
        } catch (e) {
            console.error(e)
        }
    }
    return {
        currentRow,
        visibleContextPopper,
        contextmenuPopRef,
        showContextmenuPopper
    }
}
export default useHomeContextmenu
